import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import get from 'lodash.get';
import SettingsAccountComponent from 'modules/legacy/js/components/settings-account';
import SettingsAccountComponentReadonly from 'modules/accounts/influencer/containers/AccountInfo';

function mapStateToProps({shared}) {
  const currentUser = get(shared, 'user');
  const currentAccount = get(shared, 'user.account');

  return {
    currentUser,
    currentAccount
  };
}

const BODY_COMPONENTS_BY_ROLE = {
  'influencer': SettingsAccountComponentReadonly,
  'default': SettingsAccountComponent
};

function SettingsAccount({currentUser, currentAccount}) {
  const leftDays = 0;
  const Component = BODY_COMPONENTS_BY_ROLE[currentUser.role] || BODY_COMPONENTS_BY_ROLE.default;

  return (
    <div className='vf-bg-white-color full-viewport-height'>
      <Component
        user={currentUser}
        account={currentAccount}
        updateDays={leftDays}
      />
    </div>
  );
}

SettingsAccount.propTypes = {
  currentUser: PropTypes.object,
  currentAccount: PropTypes.object,
  currentLanguage: PropTypes.string
};

export default connect(mapStateToProps)(SettingsAccount);
